import { ReactComponent as DownloadIcon } from '../../assets/icons/download.svg'

export default DownloadIcon
